document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('SizeGuideModal');
  const openBtns = document.querySelectorAll('[data-size-guide-open]');
  const closeBtns = document.querySelectorAll('[data-size-guide-close]');

  if (!modal || openBtns.length === 0) return;

  openBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    }
  });
});